import { RemoteResultAction, RemoteResultActionPayloadByRemoteResultActionType } from './index';

const remoteResultReceivedAction = (
    payload: RemoteResultActionPayloadByRemoteResultActionType['REMOTE_RESULT_RECEIVED'],
): RemoteResultAction<'REMOTE_RESULT_RECEIVED'> => {
    return {
        type: 'REMOTE_RESULT_RECEIVED',
        payload: payload,
    };
};

export const actions = {
    remoteResultReceivedAction,
};
